import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSignupMutation } from "./signupApiSlice";
import { showLoader, hideLoader } from "../../app/api/appApiSlice";

const Signup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [signup, { isSuccess, isError }] = useSignupMutation();

  const [firstName, setFirstName] = useState("");
  const [errFirstName, setErrFirstName] = useState(false);
  const [lastName, setLastName] = useState("");
  const [errLastName, setErrLastName] = useState(false);
  const [username, setUsername] = useState("");
  const [errUsername, setErrUsername] = useState(false);
  const [password, setPassword] = useState("");
  const [errPassword, setErrPassword] = useState(false);
  const [confPassword, setConfPassword] = useState("");
  const [errConfPassword, setErrConfPassword] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!firstName) {
      setErrFirstName(true);
    }

    if (!lastName) {
      setErrLastName(true);
    }

    if (!username) {
      setErrUsername(true);
    }

    if (!password) {
      setErrPassword(true);
    }

    if (!confPassword) {
      setErrConfPassword(true);
    }

    if (!firstName || !lastName || !username || !password || !confPassword) {
      return;
    }

    try {
      dispatch(showLoader());
      await signup({
        username,
        firstname: firstName,
        lastname: lastName,
        password,
      }).unwrap();
    } catch (err) {
      if (err.data?.message) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg("Please try again later.!");
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      setErrMsg("");

      setTimeout(async () => {
        setUsername("");
        setFirstName("");
        setLastName("");
        setPassword("");
        setConfPassword("");

        dispatch(hideLoader());

        navigate("/verify");
      }, 3000);
    }

    if (isError) {
      dispatch(hideLoader());
    }
  }, [isSuccess, isError]);

  return (
    <section className="flex items-center justify-center xs:min-h-[calc(100vh-68px)] py-10 mx-auto">
      <div className="flex items-center justify-center flex-wrap gap-16 sm:gap-40 p-4 xs:p-8 sm:p-20 mx-auto rounded-xl xs:shadow-lg">
        <div className="text-center">
          <img
            className="w-[300px] mx-auto mb-4"
            src="/img/dashboard.png"
            alt="intro image"
          />
          <p className="text-base sm:text-2xl">
            If you are already member?
            <br />
            Please go to the signin page.
          </p>
          <div className="mt-4">
            <Link
              className="inline-block bg-black text-white uppercase p-3 rounded-md"
              to="/"
            >
              Sign In
            </Link>
          </div>
        </div>
        <div className="flex flex-col justify-center xs:justify-start w-[300px] lg:w-[600px] max-w-[calc(100%-30px)]">
          <h1 className="text-3xl text-center uppercase mb-6">Sign Up</h1>
          <form
            className="flex flex-wrap gap-4"
            method="post"
            onSubmit={handleSubmit}
          >
            <div
              className={`w-full lg:w-[calc(50%-8px)] py-[10px] px-[12px] border-[1px] rounded-md ${
                errFirstName && "text-error border-error"
              }`}
            >
              <label htmlFor="first-name" className="block text-xs">
                First name *
              </label>
              <input
                id="first-name"
                name="first-name"
                type="text"
                className="w-full focus-visible:outline-none"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  if (e.target.value) {
                    setErrFirstName(false);
                  } else {
                    setErrFirstName(true);
                  }
                }}
                autoComplete="false"
              />
            </div>
            <div
              className={`w-full lg:w-[calc(50%-8px)] py-[10px] px-[12px] border-[1px] rounded-md ${
                errLastName && "text-error border-error"
              }`}
            >
              <label htmlFor="last-name" className="block text-xs">
                Last name *
              </label>
              <input
                id="last-name"
                name="last-name"
                type="text"
                className="w-full focus-visible:outline-none"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  if (e.target.value) {
                    setErrLastName(false);
                  } else {
                    setErrLastName(true);
                  }
                }}
                autoComplete="false"
              />
            </div>
            <div className="w-full">
              <div
                className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                  errUsername && "text-error border-error"
                }`}
              >
                <label htmlFor="username" className="block text-xs">
                  Username *
                </label>
                <input
                  id="username"
                  name="username"
                  type="email"
                  className="w-full focus-visible:outline-none"
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(e.target.value)) {
                      setErrUsername(true);
                    } else {
                      setErrUsername(false);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              {errUsername && (
                <span className="text-xs text-error">
                  Please enter a valid email address.
                </span>
              )}
            </div>
            <div className="w-full lg:w-[calc(50%-8px)]">
              <div
                className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                  errPassword && "text-error border-error"
                }`}
              >
                <label htmlFor="password" className="block text-xs">
                  Password *
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder=""
                  className="w-full focus-visible:outline-none"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (e.target.value && e.target.value.length > 8) {
                      setErrPassword(false);
                    } else {
                      setErrPassword(true);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              {errPassword && (
                <span className="text-xs text-error">
                  Password must be more than 8 characters long.
                </span>
              )}
            </div>
            <div className="w-full lg:w-[calc(50%-8px)]">
              <div
                className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                  errConfPassword && "text-error border-error"
                }`}
              >
                <label htmlFor="conf-password" className="block text-xs">
                  Confirm Password *
                </label>
                <input
                  id="conf-password"
                  name="conf-password"
                  type="password"
                  placeholder=""
                  className="w-full focus-visible:outline-none"
                  value={confPassword}
                  onChange={(e) => {
                    setConfPassword(e.target.value);
                    if (e.target.value && password === e.target.value) {
                      setErrConfPassword(false);
                    } else {
                      setErrConfPassword(true);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              {errConfPassword && (
                <span className="text-xs text-error">
                  Password does not matched.
                </span>
              )}
            </div>
            <div className="w-full text-center">
              <button
                type="submit"
                className="max-w-fit bg-black text-white uppercase p-3 rounded-md"
              >
                Sign Up
              </button>
            </div>
            {errMsg && (
              <div className="max-w-max text-center text-error py-2 px-4 mx-auto rounded-md">
                {errMsg}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Signup;
